import { useState } from "react";

const FEATURES = [
  { id: "large", label: "Large PDF handling", color: "text-violet-300", badge: "bg-violet-500/20 text-violet-300 border-violet-500/40", title: "Page-scale CIB reports", body: "Designed for CIB reports with hundreds of pages and tested successfully against reports exceeding 1,000 pages without replacing the extraction engine." },
  { id: "fields", label: "Financial extraction", color: "text-cyan-300", badge: "bg-cyan-500/20 text-cyan-300 border-cyan-500/40", title: "Structured financial fields", body: "Extracts required CIB information such as Gross STD through BLW, Stay Order, Last Reporting Date, CIB Date, and related report values used by the validation workflow." },
  { id: "progress", label: "Page-level progress", color: "text-sky-300", badge: "bg-sky-500/20 text-sky-300 border-sky-500/40", title: "Live current-PDF state", body: "Processing can expose the current PDF, current page, page count, stage, and batch-level progress so long-running reports remain observable." },
  { id: "cancel", label: "Cooperative cancellation", color: "text-amber-300", badge: "bg-amber-500/20 text-amber-300 border-amber-500/40", title: "STOP-safe scanning", body: "The extraction loop checks cancellation state while processing pages, allowing queued work to be stopped before starting and active PDFs to cooperate with cancellation." },
];

export default function PDFExtractionEngine() {
  const [active, setActive] = useState("large");
  const item = FEATURES.find((x) => x.id === active);

  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">PDF EXTRACTION ENGINE</p>
        <h4 className="mt-1 text-sm font-semibold text-white">PyMuPDF-based page processing</h4>
        <p className="mt-1 text-xs text-slate-400">The expensive PDF work stays independent from scheduling and database coordination, preserving extraction behavior while enabling safe concurrency.</p>
      </div>

      <div className="flex gap-3">
        <div className="w-40 shrink-0 space-y-0.5">
          <p className="mb-2 font-mono text-[9px] tracking-[0.15em] text-slate-600">ENGINE CAPABILITIES</p>
          {FEATURES.map((x) => (
            <button key={x.id} onClick={() => setActive(x.id)} className={`flex w-full items-center gap-2 rounded-lg border px-2.5 py-2 text-left text-[11px] transition ${active === x.id ? `${x.badge} font-semibold` : "border-transparent text-slate-400 hover:bg-white/5 hover:text-slate-200"}`}>
              <span className="truncate">{x.label}</span>
            </button>
          ))}
        </div>

        {item && (
          <div className="min-w-0 flex-1 space-y-2">
            <div className={`rounded-xl border p-3 ${item.badge}`}>
              <p className="text-sm font-bold">{item.title}</p>
              <p className="mt-0.5 text-[10px]">{item.label}</p>
            </div>
            <div className="rounded-lg border border-white/10 bg-black/20 p-3">
              <p className={`mb-1 font-mono text-[9px] tracking-[0.15em] ${item.color}`}>ENGINE BEHAVIOUR</p>
              <p className="text-[11px] leading-relaxed text-slate-400">{item.body}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
